import SituacionLaboralCreate from './SituacionLaboralCreate'
export {SituacionLaboralCreate}
export default SituacionLaboralCreate
